/** Portal bundle template ZIP limits (design defaults). */
export const PORTAL_BUNDLE_TEMPLATE_MAX_BYTES = 2 * 1024 * 1024;
export const PORTAL_BUNDLE_MAX_ENTRIES = 64;
export const PORTAL_BUNDLE_MAX_UNCOMPRESSED = 4 * 1024 * 1024;
export const PORTAL_BUNDLE_MAX_FILE_BYTES = 512 * 1024;
export const PORTAL_BUNDLE_MAX_COMPRESSION_RATIO = 100;
export const PORTAL_BUNDLE_MAX_PATH_LENGTH = 180;
export const PORTAL_BUNDLE_ZIP_PREFIX = "hotspot/";
export const PORTAL_BUNDLE_TEMPLATE_STATUSES = ["draft", "verified", "retired"];
export const PORTAL_BUNDLE_JOB_STATUSES = [
    "queued",
    "generating",
    "ready",
    "failed",
    "expired",
    "revoked",
];
/** Authoritative rc.16 bundle template (vital-telecom hotspot-release-rc16-042). */
export const PORTAL_BUNDLE_RC16_RELEASE_ID = "0.0.0-rc.16";
export const PORTAL_BUNDLE_RC16_SHA256 = "3f575648ca27038a59695551f915692fe78d192017f0cd1dff8ca1ac036fdc58";
export const PORTAL_BUNDLE_RC16_FILE_COUNT = 35;
/** Authoritative rc.17 bundle template (vital-telecom hotspot-release-rc17-045) — reseller branding renderer. */
export const PORTAL_BUNDLE_RC17_RELEASE_ID = "0.0.0-rc.17";
export const PORTAL_BUNDLE_RC17_SHA256 = "1e3ee8b652771bb7ef67817ee6a04018ea8787a7202ac8261592f0f8f86694a4";
export const PORTAL_BUNDLE_RC17_FILE_COUNT = 35;
/** Authoritative rc.18 bundle template (vital-telecom hotspot-release-rc18-048) — F1 fold-priority. Frozen. */
export const PORTAL_BUNDLE_RC18_RELEASE_ID = "0.0.0-rc.18";
export const PORTAL_BUNDLE_RC18_SHA256 = "dc33da67559c8b93b3f127acd906b443fbd7b0d3cfe1e275e8e981fe6d93eb39";
export const PORTAL_BUNDLE_RC18_FILE_COUNT = 35;
export const PORTAL_BUNDLE_RC18_BYTE_SIZE = 145116;
/** Authoritative rc.19 bundle template (vital-telecom hotspot-release-rc19-050) — C6A cross-page reseller branding. Frozen. */
export const PORTAL_BUNDLE_RC19_RELEASE_ID = "0.0.0-rc.19";
export const PORTAL_BUNDLE_RC19_SHA256 = "ab111baee22130360a7ba426a8d9736ffbdadf6ea2df41bea00fe119858654b2";
export const PORTAL_BUNDLE_RC19_FILE_COUNT = 35;
export const PORTAL_BUNDLE_RC19_BYTE_SIZE = 145443;
/** Authoritative rc.20 bundle template (vital-telecom hotspot-release-rc20-055) — C6B multilingual portal. Frozen. */
export const PORTAL_BUNDLE_RC20_RELEASE_ID = "0.0.0-rc.20";
export const PORTAL_BUNDLE_RC20_SHA256 = "5b3ec0e4bcd11d71d308489823f7259d09441cfed0b068dcaa94743bb530c57b";
export const PORTAL_BUNDLE_RC20_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC20_BYTE_SIZE = 157365;
/** Authoritative rc.21 bundle template (vital-telecom hotspot-portal-c7d-058) — C7D sponsored login slot. */
export const PORTAL_BUNDLE_RC21_RELEASE_ID = "0.0.0-rc.21";
export const PORTAL_BUNDLE_RC21_SHA256 = "96d0e632a4c5dab333c3a4a98136496f51698e982fd7dcbb699492deb28bf540";
export const PORTAL_BUNDLE_RC21_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC21_BYTE_SIZE = 158798;
/** Authoritative rc.22 bundle template (vital-telecom hotspot-support-call-rc22) — support call CTA. Frozen. */
export const PORTAL_BUNDLE_RC22_RELEASE_ID = "0.0.0-rc.22";
export const PORTAL_BUNDLE_RC22_SHA256 = "892fd2c3d4a076bd78d99f06118c93a0f0b194d19285b6243481a5f167d2976d";
export const PORTAL_BUNDLE_RC22_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC22_BYTE_SIZE = 158810;
/** Authoritative rc.23 bundle template (vital-telecom hotspot-tofan-branding-rc23) — Tofan Portal branding. Frozen. */
export const PORTAL_BUNDLE_RC23_RELEASE_ID = "0.0.0-rc.23";
export const PORTAL_BUNDLE_RC23_SHA256 = "ee6a4f0dcba221cc1ddcd49ab59f0994664a6a9095d34e5e371ebdb0f4186226";
export const PORTAL_BUNDLE_RC23_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC23_BYTE_SIZE = 194449;
/** Authoritative rc.24 bundle template — login slogan/terms company + call-only support. Frozen. */
export const PORTAL_BUNDLE_RC24_RELEASE_ID = "0.0.0-rc.24";
export const PORTAL_BUNDLE_RC24_SHA256 = "3c10b291b0952c2c2158ca0b1cf31d7332020bdaef2eeaf3b2c8c2b72fc37833";
export const PORTAL_BUNDLE_RC24_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC24_BYTE_SIZE = 194704;
/** Authoritative rc.25 bundle template — reseller name in login/terms provider text. Frozen. */
export const PORTAL_BUNDLE_RC25_RELEASE_ID = "0.0.0-rc.25";
export const PORTAL_BUNDLE_RC25_SHA256 = "a2cdc5a4518642c6874b85ab3e6baf268eaafecbd57d709e65d00cff530195b5";
export const PORTAL_BUNDLE_RC25_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC25_BYTE_SIZE = 194936;
/** Authoritative rc.26 bundle template — MikroTik login error map fix. Frozen. */
export const PORTAL_BUNDLE_RC26_RELEASE_ID = "0.0.0-rc.26";
export const PORTAL_BUNDLE_RC26_SHA256 = "e447c24ea481f6fc7f3fadaba6f7a1b3fe526f9d387858bb0244adb8c4a53856";
export const PORTAL_BUNDLE_RC26_FILE_COUNT = 43;
export const PORTAL_BUNDLE_RC26_BYTE_SIZE = 195134;
/** Only per-site file the CMS generator may replace. */
export const PORTAL_BUNDLE_RUNTIME_CONFIG_REL_PATH = "js/vital-portal-runtime-config.js";
/** Default artifact download availability (days). */
export const PORTAL_BUNDLE_ARTIFACT_EXPIRY_DAYS = 30;
/** DB provenance retention (days). */
export const PORTAL_BUNDLE_PROVENANCE_RETENTION_DAYS = 365;
/** Expected deployable files inside hotspot/ (identical for rc.16 and rc.17). */
export const PORTAL_BUNDLE_RC16_EXPECTED_FILES = [
    "alogin.html",
    "api.json",
    "css/style.css",
    "css/vital-hotspot.css",
    "error.html",
    "errors.txt",
    "favicon.ico",
    "fonts/OFL.txt",
    "fonts/Vazirmatn-Bold.woff2",
    "fonts/Vazirmatn-Regular.woff2",
    "img/password.svg",
    "img/user.svg",
    "img/vtl-logo.png",
    "img/vtl-logo.svg",
    "img/vtl-mark.svg",
    "js/md5.js",
    "js/vital-config.example.js",
    "js/vital-hotspot.js",
    "js/vital-portal-content.js",
    "js/vital-portal-runtime-config.js",
    "js/vital-remote-content.js",
    "login.html",
    "logout.html",
    "radvert.html",
    "redirect.html",
    "rlogin.html",
    "status.html",
    "terms.html",
    "xml/WISPAccessGatewayParam.xsd",
    "xml/alogin.html",
    "xml/error.html",
    "xml/flogout.html",
    "xml/login.html",
    "xml/logout.html",
    "xml/rlogin.html",
];
export const PORTAL_BUNDLE_RC17_EXPECTED_FILES = PORTAL_BUNDLE_RC16_EXPECTED_FILES;
export const PORTAL_BUNDLE_RC18_EXPECTED_FILES = PORTAL_BUNDLE_RC16_EXPECTED_FILES;
export const PORTAL_BUNDLE_RC19_EXPECTED_FILES = PORTAL_BUNDLE_RC16_EXPECTED_FILES;
export const PORTAL_BUNDLE_RC20_EXPECTED_FILES = [
    ...PORTAL_BUNDLE_RC16_EXPECTED_FILES,
    "js/i18n/vital-i18n-boot.js",
    "js/i18n/vital-i18n.js",
    "js/i18n/vital-terms-en.js",
    "js/i18n/vital-terms-fa-AF.js",
    "js/i18n/vital-terms-ps-AF.js",
    "js/i18n/vital-ui-en.js",
    "js/i18n/vital-ui-fa-AF.js",
    "js/i18n/vital-ui-ps-AF.js",
];
export const PORTAL_BUNDLE_RC21_EXPECTED_FILES = PORTAL_BUNDLE_RC20_EXPECTED_FILES;
export const PORTAL_BUNDLE_RC22_EXPECTED_FILES = PORTAL_BUNDLE_RC20_EXPECTED_FILES;
/** rc.23 replaces Vital `vtl-*` brand assets with Tofan mark paths. */
export const PORTAL_BUNDLE_RC23_EXPECTED_FILES = [
    "alogin.html",
    "api.json",
    "css/style.css",
    "css/vital-hotspot.css",
    "error.html",
    "errors.txt",
    "favicon.ico",
    "fonts/OFL.txt",
    "fonts/Vazirmatn-Bold.woff2",
    "fonts/Vazirmatn-Regular.woff2",
    "img/password.svg",
    "img/tofan-logo.png",
    "img/tofan-logo.svg",
    "img/tofan-mark.svg",
    "img/user.svg",
    "js/i18n/vital-i18n-boot.js",
    "js/i18n/vital-i18n.js",
    "js/i18n/vital-terms-en.js",
    "js/i18n/vital-terms-fa-AF.js",
    "js/i18n/vital-terms-ps-AF.js",
    "js/i18n/vital-ui-en.js",
    "js/i18n/vital-ui-fa-AF.js",
    "js/i18n/vital-ui-ps-AF.js",
    "js/md5.js",
    "js/vital-config.example.js",
    "js/vital-hotspot.js",
    "js/vital-portal-content.js",
    "js/vital-portal-runtime-config.js",
    "js/vital-remote-content.js",
    "login.html",
    "logout.html",
    "radvert.html",
    "redirect.html",
    "rlogin.html",
    "status.html",
    "terms.html",
    "xml/WISPAccessGatewayParam.xsd",
    "xml/alogin.html",
    "xml/error.html",
    "xml/flogout.html",
    "xml/login.html",
    "xml/logout.html",
    "xml/rlogin.html",
];
export const PORTAL_BUNDLE_RC24_EXPECTED_FILES = PORTAL_BUNDLE_RC23_EXPECTED_FILES;
export const PORTAL_BUNDLE_RC25_EXPECTED_FILES = PORTAL_BUNDLE_RC23_EXPECTED_FILES;
export const PORTAL_BUNDLE_RC26_EXPECTED_FILES = PORTAL_BUNDLE_RC23_EXPECTED_FILES;
/** Exact file catalogs the CMS may import. */
export const PORTAL_BUNDLE_KNOWN_FILE_CATALOGS = [
    PORTAL_BUNDLE_RC16_EXPECTED_FILES,
    PORTAL_BUNDLE_RC20_EXPECTED_FILES,
    PORTAL_BUNDLE_RC23_EXPECTED_FILES,
];
export function matchPortalBundleFileCatalog(files) {
    const sorted = [...files].sort();
    for (const catalog of PORTAL_BUNDLE_KNOWN_FILE_CATALOGS) {
        const expected = [...catalog].sort();
        if (sorted.length === expected.length && sorted.every((file, i) => file === expected[i])) {
            return { ok: true, fileCount: catalog.length };
        }
    }
    const allowedUnion = new Set([
        ...PORTAL_BUNDLE_RC20_EXPECTED_FILES,
        ...PORTAL_BUNDLE_RC23_EXPECTED_FILES,
    ]);
    for (const file of sorted) {
        if (!allowedUnion.has(file)) {
            return { ok: false, code: "unexpected_file", message: `Unexpected file: ${file}` };
        }
    }
    const rc16Set = new Set(PORTAL_BUNDLE_RC16_EXPECTED_FILES);
    const usesRc20Plus = sorted.some((file) => !rc16Set.has(file));
    const usesTofanLogo = sorted.some((file) => file.startsWith("img/tofan-"));
    const required = usesTofanLogo
        ? PORTAL_BUNDLE_RC23_EXPECTED_FILES
        : usesRc20Plus
            ? PORTAL_BUNDLE_RC20_EXPECTED_FILES
            : PORTAL_BUNDLE_RC16_EXPECTED_FILES;
    const missing = required.find((file) => !sorted.includes(file));
    return {
        ok: false,
        code: "missing_required_file",
        message: `Missing required file: ${missing ?? required[0]}`,
    };
}
//# sourceMappingURL=portal-bundle.js.map